import { GenericAbortSignal } from 'axios';

import { Collaboration, CollaborationOptions } from 'models/flexible/Collaboration';
import { Paginated } from 'models/flexible/Paginated';
import type {
  AdminCollaborationIndexFields,
  AdminCollaborationIndexInclude,
  AdminCollaborationUpdateParams,
} from 'services/api/fields';
import { BaseIndexQueryParams } from 'services/api/types';
import http from 'services/http';

export const adminCollaborationsQueryKeys = {
  index: (params?: Record<string, any>) => ['adminCollaborations', params] as const,
};

const URL = 'admin/collaborations';

export type AdminCollaborationIndexParams = BaseIndexQueryParams & {
  physicianGroup?: string;
  healthSystem?: string;
};

export async function adminIndexCollaborations<I extends AdminCollaborationIndexInclude = never>(
  params: AdminCollaborationIndexParams,
  signal?: GenericAbortSignal,
  includes?: I[]
): Promise<Paginated<Collaboration<AdminCollaborationIndexFields<I>>>> {
  return http
    .get<
      Paginated<CollaborationOptions>
    >(URL, { params: { ...params, ...(includes?.length ? { include: includes.join(',') } : {}) }, signal })
    .then((res) => ({
      ...res.data,
      data: res.data.data.map((x) => new Collaboration(x)),
    })) as Promise<Paginated<Collaboration<AdminCollaborationIndexFields<I>>>>;
}

export async function adminUpdateCollaboration(id: string, params: AdminCollaborationUpdateParams) {
  return http.patch<CollaborationOptions>(`${URL}/${id}`, params).then((res) => new Collaboration(res.data));
}
